// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FieldBinaryOutlinedSvg from "@fishx/icons-svg/es/asn/FieldBinaryOutlined";
import FishxIcon from '../components/FishxIcon';

var FieldBinaryOutlined = function FieldBinaryOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FieldBinaryOutlinedSvg
  }));
};

FieldBinaryOutlined.displayName = 'FieldBinaryOutlined';
export default React.forwardRef(FieldBinaryOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FieldBinaryOutlined.js
// module id = 2671
// module chunks = 0